<template>
  <div class="container-table">

    <div class="row divAddDatoIntermedio">

      <div class="col-12">
        <q-btn
          unelevated
          icon="add"
          class="bPrincipal rigth"
          label="AÑADIR DATO INTERMEDIO"
          @click="triggerAdd()"
          :style="isOnlyAccess || isCiudadano ? 'display: none': ''"
        />
      </div>
    </div>

    <PopUpInputDatosIntermedios v-model="showPopUpAddNewDato" :row="currentDatoIntermedio" @saveDato="saveDato"/>

    <q-card-section>
      <q-table
        data-cy="accion-instrumeto-table"
        :data="datosIntermedios"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :visible-columns="visibleColumns"
      >
        <template v-slot:body-cell-value="props">
          <q-td key="value" :props="props">
            {{ props.row.value }}
          </q-td>
        </template>
        <template v-slot:body-cell-date="props">
          <q-td key="date" :props="props">
            {{ props.row.date }}
          </q-td>
        </template>

        <template v-slot:body-cell-editar="props">
            <q-td key="editar" :props="props">
                <q-icon
                  name="o_create"
                  style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
                  @click="triggerEdit(props.row)"
                />
              </q-td>
          </template>

        <template v-slot:body-cell-eliminar="props">
          <q-td key="eliminar" :props="props">
            <q-icon
              name="o_delete"
              style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
              @click="triggerDelete(props.row)"
            />
          </q-td>
        </template>
      </q-table>
    </q-card-section>
    <DialogDelete
      v-if="rowSelectedtoDelete"
      v-model="showDialogDelete"
      :showIcon="true"
      :txtContainer="
        `¿Está seguro de eliminar el dato intermedio?`
      "
      @save="deleteDatoIntermedio()"
    />
  </div>
</template>
<script>
import { QTable, QTd, QCardSection } from 'quasar';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import PopUpInputDatosIntermedios from '../components/PopUpInputDatosIntermedios.vue';
import Vue from 'vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  components: {
    QTable,
    QTd,
    QCardSection,
    PopUpInputDatosIntermedios,
    DialogDelete
  },
  mixins: [Loading],
  props: {
    datosIntermedios: Array,
    idIndicadorCiudad: String,
    datosPartidaObjetivo: Object
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isOnlyAccess: 'NGUD/isOnlyAccess',
      isCiudadano: 'NGUD/isCiudadano'
    })
  },
  data () {
    return {
      rowSelectedtoDelete: null,
      pagination: {
        rowsPerPage: 20
      },
      showDialogDelete: false,
      showPopUpAddNewDato: false,
      currentDatoIntermedio: {},
      visibleColumns: ['value', 'date', 'editar', 'eliminar'],
      columns: [
        {
          name: 'value',
          label: 'Dato intermedio',
          align: 'left',
          field: 'value',
          sortable: true
        },
        {
          name: 'date',
          label: 'Fecha',
          align: 'left',
          field: 'date',
          sortable: true
        },
        {
          name: 'editar',
          label: 'Editar',
          align: 'center',
          field: '',
          sortable: false
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  created () {
    this.visibleColumns = this.isOnlyAccess || this.isCiudadano ? ['value', 'date'] : ['value', 'date', 'editar', 'eliminar'];
  },
  methods: {
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      this.showDialogDelete = true;
    },
    deleteDatoIntermedio () {
      // obtenemos indice
      const index = this.datosIntermedios.indexOf(this.rowSelectedtoDelete);
      // eliminamos el elemento
      this.datosIntermedios.splice(index, 1);
      this.showDialogDelete = false;
      // llamar a endpoint emviandole el array de datos
      this.saveDatosIntermedios();
    },
    triggerAdd () {
      this.currentDatoIntermedio = {};
      this.showPopUpAddNewDato = true;
    },
    saveDato (newDato) {
      if (newDato.hasOwnProperty('position')) {
        this.datosIntermedios[newDato.position] = newDato;
        Vue.set(this.datosIntermedios, newDato.position, newDato);
      } else {
        this.datosIntermedios.push(newDato);
      }
      // llamar a endpoint emviandole el array de datos
      this.saveDatosIntermedios();
    },
    async saveDatosIntermedios () {
      let arrayDatosIntermedios = [];
      this.datosIntermedios.forEach(element => {
        let objectFromated = {
          value: element.value,
          date: moment(new Date(element.date)).format('YYYY-MM-DD')
        };
        arrayDatosIntermedios.push(objectFromated);
      });

      this.showLoading();
      await this.$store.dispatch(types.ACTION_SAVE_DATOS_INTERMEDIOS, {
        idCiudad: this.ciudadSelected.id,
        idCiudadIndicadorAUE: this.idIndicadorCiudad,
        datosIntermedios: arrayDatosIntermedios,
        datosPartidaObjetivo: this.datosPartidaObjetivo
      }).then(response => {
        this.hideLoading();
        // lanzar evento para actualizar gráfica con datos intermedios
        this.$eventHub.$emit('updateIndicadorAUE', response.data.id);
      }).catch(() => {
        this.hideLoading();
      });
    },
    triggerEdit (row) {
      const index = this.datosIntermedios.indexOf(row);
      row['position'] = index;
      this.currentDatoIntermedio = row;
      this.showPopUpAddNewDato = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.container-table {
  margin-top: 15px;
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
      border: solid 3px #e9f4f6;
      border-radius: 12px;
    }
  }
  .divAddDatoIntermedio {
    margin-bottom: 15px;
  }
  .rigth {
    float: right;
  }
}
</style>
